module.exports = __webpack_public_path__ + "img/rights-title.add08311.jpg";